export const dictConstants = {
    role: {
        participant: 'Участник',
        assistant: 'Помощник'
    }
};
